import React from 'react';

import { bm } from '@skippay/core/utils/classUtils';

import './index.sass';

const MODULE_NAME = 'SkeletonPlaceholder';

interface Props {
	circle?: boolean;
	className?: string;
	height?: string;
	largeBorderRadius?: boolean;
	light?: boolean;
	margin?: string;
	width?: string;
}

function SkeletonPlaceholder(props: Props): JSX.Element {
	const { circle, className, height, largeBorderRadius, light, margin, width } = props;
	return (
		<div
			className={bm(MODULE_NAME, { circle, largeBorderRadius, light }, className)}
			style={{ height, margin, width }}
		/>
	);
}

export default SkeletonPlaceholder;
